import React from 'react';
import useOrganization from '../../../hooks/use-organization';
import AdminDetails from './admin-details';
import OrganizationAdminDetails from '../organization/organization-admin-details';

// Dispatches the admin details route between the system and organization flows,
// mirroring `settings/index.tsx` and `admin-add-index.tsx`. Organization mode is
// keyed on the `organizationId` query param (via `useOrganization`).
const AdminDetailsIndex: React.FC<any> = (props) => {
  const organizationInfo = useOrganization();

  return Boolean(organizationInfo?.id) ? (
    <OrganizationAdminDetails />
  ) : (
    <AdminDetails {...props} />
  );
};

export default AdminDetailsIndex;
